$shm_hitalama_map_widget_float_layout_hor $shm_hitalama_map_widget_float_group
	gap 0
	padding_top 0
	padding_bottom 0
	padding_left 0
	padding_right 0
	add_types /
	tools_custom /
	auto /
		^
		<= candidates_drag null
		<= arrange null
	candidate_links? /$giper_baza_link
	candidate_pos? -1
	candidates? /$shm_hitalama_map_widget_any
	move_widgets_to_places null
	controls /
		- <= Includes
		^ new_pos_visible /
			<= New_pos $mol_view
				style *
					width <= new_pos_width_px \0px
					left <= new_pos_left_px \0px
	Includes $mol_view
		sub / <= includes \
	contextmenu_body /
		<= Add_to_container $mol_pop_over
			align \right_bottom
			Anchor <= Add_to_container_anchor $mol_button_minor
				title \Добавить в контейнер
			bubble_content /
				<= Add_to_container_menu $shm_hitalama_map_page_contextmenu
					Map_page <= Map_page
					widget_add* <= contextmenu_widget_add* null
		^
	settings_content /
		<= Items_label $mol_paragraph
			title <= items_label \Элементы
		<= Items $mol_list
			sub <= items / <= Item*0 $mol_text
				text <= item_title* \
